import { render, staticRenderFns } from "./SocialMedias.vue?vue&type=template&id=39817d7a"
import script from "./SocialMedias.vue?vue&type=script&lang=ts"
export * from "./SocialMedias.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports